import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { useConnect } from 'sb-redux-hook'
import { useCallback } from 'sb-hooks'

import Icon from 'components/_new/ui/Icon/Icon'
import Button from 'components/_new/Button/Button'
import SocialButton from 'components/_new/buttons/SocialButton/SocialButton'

import messages from './messages'
import s from './FacebookButton.scss'


const FacebookButton = ({ className, rounded, onClick }) => {
  const { facebookReferralCode } = useConnect({
    facebookReferralCode: (state) => state.models.me.referralCodes ? state.models.me.referralCodes.facebook : null,
  })

  const handleClick = useCallback(() => {
    actions.models.me.stopInviteTracking()

    if (typeof onClick === 'function') {
      onClick()
    }

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${facebookReferralCode}`,
      'Facebook',
      'width=500, height=500'
    )
  }, [ facebookReferralCode, onClick ])

  return rounded ? (
    <Button
      className={cx(s.roundButton, className)}
      size="md"
      color={null}
      ariaLabel="Share on Facebook"
      loading={Boolean(!facebookReferralCode)}
      dataTestId={constants.testIds.invite.facebookButton}
      onClick={handleClick}
    >
      <Icon
        className={s.icon}
        name="facebook"
        color="white"
      />
    </Button>
  ) : (
    <SocialButton
      title={messages.buttonTitle}
      size="md"
      type="facebook"
      ariaLabel="Share on Facebook"
      loading={Boolean(!facebookReferralCode)}
      dataTestId={constants.testIds.invite.facebookButton}
      fullWidthOnMobile
      onClick={handleClick}
    />
  )
}

FacebookButton.propTypes = {
  rounded: PropTypes.bool,
  onClick: PropTypes.func,
}


export default FacebookButton
